import {shopSellerService} from 'services/seller';
import {getConnectionById} from 'utils/seller/sellerConnectionData';
import {ID_OZON_SELLER_API_CONNECTION} from 'utils/seller/const';

export const CREATE_NEW_SHOP = 'CREATE_NEW_SHOP';
export const FETCH_SHOP_CURRENT_USER = 'FETCH_SHOP_CURRENT_USER';
export const SET_SHOPS = 'SET_SHOPS';
export const DELETE_SHOP = 'DELETE_SHOP';

const shopsStore = {
  namespaced: true,
  state: {
    shops: []
  },
  getters: {
    getShops (state) {
      return state.shops;
    },
    getShopsChannelIdListForCurrentUser (state) {
      return state.shops.map(shop => shop.channel_id);
    },
    getUniqueShopsListForCurrentUser (state) {
      return state.shops.map(shop => {
        const connection = getConnectionById(shop.channel_id);
        return {
          id: connection.channelId,
          display_name: connection.display_name,
          icon: connection.icon
        };
      });
    },
    getChannelById: () => (channelId) => getConnectionById(channelId)
  },
  mutations: {
    [SET_SHOPS] (state, shops) {
      state.shops = shops;
    }
  },
  actions: {
    async [CREATE_NEW_SHOP] (context, payload) {
      await shopSellerService.createShop(payload);
      context.dispatch(FETCH_SHOP_CURRENT_USER);
    },
    async [DELETE_SHOP] (context, shopId) {
      const newShopList = context.state.shops.filter(shop => shop.id !== shopId);
      context.commit(SET_SHOPS, newShopList);

      await shopSellerService.deleteShop(shopId);
      return await context.dispatch(FETCH_SHOP_CURRENT_USER);
    },
    async [FETCH_SHOP_CURRENT_USER] (context) {
      const shops = (await shopSellerService.getShopsCurrentUser()).items;
      const shopsWithoutSellerApiConnections = shops.filter(shop => shop.channel_id !== ID_OZON_SELLER_API_CONNECTION);
      context.commit(SET_SHOPS, shopsWithoutSellerApiConnections);
    }
  }
};

export default shopsStore;
